import { AxiosInstance } from 'axios';
import { CategoryDTO, CreateCategoryDefaultParams, CreateCategoryParams, CreateLabelParams } from '../../types/apiType';

export default class CategoryServices {
  constructor(private axios: AxiosInstance) {}

  getCategoryAdmin = async (): Promise<CategoryDTO[]> => {
    const { data } = await this.axios.get('category');
    return data;
  };

  createCategoryAdmin = async (params: CreateCategoryParams[]): Promise<null> => {
    const { data } = await this.axios.post('category', params);
    return data;
  };

  createCategoryDefaultAdmin = async (params: CreateCategoryDefaultParams[]): Promise<null> => {
    const { data } = await this.axios.post('category/default', params);
    return data;
  };

  createLabels = async (params: CreateLabelParams[]): Promise<null> => {
    const { data } = await this.axios.post('category/label', params);
    return data;
  };

  deleteCategoryAdmin = async (ids: string[]): Promise<null> => {
    const { data } = await this.axios.delete('category', { data: ids });
    return data;
  };

  deleteLabelAdmin = async (ids: string[]): Promise<null> => {
    const { data } = await this.axios.delete('category/label', { data: ids });
    return data;
  };
}
